// Centralized product slug canonicalizer
// Converts various UI/form slugs to the canonical database slug (underscored)
// Keep mappings exhaustive for known variants and safe fallback to hyphen->underscore.

export const canonicalizeProductSlug = (slug?: string): string => {
  if (!slug) return '';
  const s = String(slug).toLowerCase().trim();
  // Normalize spaces to hyphens for matching keys
  const normalized = s.replace(/\s+/g, '-');

  const map: Record<string, string> = {
    // Property
    'property-all-risks': 'property_all_risks',
    'property_all_risks': 'property_all_risks',
    'property-all-risks-insurance': 'property_all_risks',

    // Third party / Public liability
    'third-party-liability': 'public_liability',
    'third-party-liability-insurance': 'public_liability',
    'public-liability': 'public_liability',
    'public_liability': 'public_liability',

    // Workers compensation
    'workers-compensation': 'workmens_comp',
    'workers-compensation-insurance': 'workmens_comp',
    'workers-comp': 'workmens_comp',
    'workmens-comp': 'workmens_comp',
    'workmens_comp': 'workmens_comp',

    // Employee medical
    'employee-medical': 'employee_medical',
    'employee-medical-insurance': 'employee_medical',
    'employee_medical': 'employee_medical',

    // Professional indemnity
    'professional-indemnity': 'professional_indemnity',
    'professional-indemnity-insurance': 'professional_indemnity',
    'professional_indemnity': 'professional_indemnity',

    // Product liability
    'product-liability': 'product_liability',
    'product-liability-insurance': 'product_liability',
    'product_liability': 'product_liability',

    // Business interruption
    'business-interruption': 'business_interruption',
    'business-interruption-insurance': 'business_interruption',
    'business_interruption': 'business_interruption',

    // Cyber
    'cyber': 'cyber',
    'cyber-insurance': 'cyber',
    'cyber-protection': 'cyber',

    // Fleet / motor fleet
    'fleet': 'fleet',
    'fleet-insurance': 'fleet',
    'motor-fleet': 'fleet',
    'commercial-motor': 'fleet',

    // SME Package
    'sme-package': 'sme_package',
    'sme_package': 'sme_package',
  };

  return map[normalized] ?? map[s] ?? s.replace(/-/g, '_');
};

export default canonicalizeProductSlug;

